<template>
    <div class="home-quote-step home-date">
        <quote-step-header
            :title="this.step.step_fields.default.title"
            :key="this.step.step_fields.default.title"
            :subtitle="this.step.step_fields.default.subtitle"
        ></quote-step-header>
        <form class="quote-form" @submit.prevent="next">
            <div class="form-row center sm:my-6">
                <div class="start-insurance-date">
                    <div class="flex flex-wrap mb-12">
                        <app-label>
                            {{ trans("date_label") }}
                        </app-label>

                        <app-text-radio-buttons
                            v-model="form[stepName].whenStart"
                            :breakMobile="true"
                            :items="whenStart"
                        />
                    </div>

                    <div
                        v-if="form[stepName].whenStart === constants.custom"
                        class="flex flex-wrap mb-12 flex-col"
                    >
                        <app-label>
                            {{ trans("select_start_date") }}
                        </app-label>

                        <app-date-range-manual
                            v-model="form[stepName].startDate"
                            :disabled-dates="disabledDates"
                            :end-date="endDate"
                            :length-text="trans('insurance_length')"
                            :placeholder="trans('select_date')"
                            center
                            hide-range-text
                        >
                        </app-date-range-manual>
                    </div>

                    <div class="mt-5 lg:mt-10">
                        <app-label>
                            {{ trans("insured_connection") }}
                        </app-label>

                        <app-text-radio-buttons
                            v-model="form[stepName].insuredConnection"
                            :breakMobile="true"
                            :items="insuredConnection"
                        />
                    </div>

                    <div class="mt-5 lg:mt-10">
                        <app-label>
                            {{ trans("insurance_type") }}
                        </app-label>

                        <app-text-radio-buttons
                            v-model="form[stepName].insuranceType"
                            :breakMobile="true"
                            :items="insuranceType"
                        />
                    </div>

                    <!-- <div v-if="isContentType" class=" mt-5 lg:mt-10">
                        <app-label>
                            {{ trans("content_amount") }}
                        </app-label>

                        <app-input
                            type="number"
                            v-model="form[stepName].contentAmount"
                            :message="errors.get('content_amount')"
                        />

                        <div
                            v-if="form[stepName].contentAmount"
                            class="text-right text-gray-400 text-sm my-2"
                        >
                            {{ trans("content_amount_jewelry") }}
                            {{ jewelryAmount }}
                        </div>
                    </div> -->
                    <!-- 
                    <div
                        v-if="
                            form[stepName].insuranceType !== constants.content
                        "
                        class="mt-5 lg:mt-10"
                    > -->
                    <!-- <div class="lg:mt-10">
                            <app-label>
                                {{ trans("content_earth_quake") }}
                            </app-label>

                            <app-text-radio-buttons
                                v-model="form[stepName].earthQuake"
                                :breakMobile="true"
                                :items="earthQuakeItem"
                            />
                        </div> -->

                    <!-- <div class="lg:mt-10">
                            <app-label>
                                {{ trans("pipeline_damage") }}
                            </app-label>

                            <app-text-radio-buttons
                                v-model="form[stepName].pipelineDamage"
                                :breakMobile="true"
                                :items="pipelineDamageItem"
                            />
                        </div> -->
                    <!-- </div> -->
                </div>
            </div>

            <div class="submit-row">
                <app-button :disabled="disabledConditions" :loading="loading">
                    {{ "quote.welcome.next" | __ }}
                </app-button>
            </div>
        </form>
    </div>
</template>

<script>
import QuoteStep from "../../../mixins/QuoteStep";
import AppSelect from "../../Forms/Select.vue";
import AppTextRadioButtons from "../../Forms/TextRadioButtons.vue";
import AppAutocompleteInput from "../../Forms/AutocomplateInput";
import AppInput from "../../Forms/Input.vue";
import moment from "moment/moment";

export default {
    name: "HomeQuoteSelectDate",
    components: {
        AppInput,
        AppAutocompleteInput,
        AppSelect,
        AppTextRadioButtons
    },
    mixins: [QuoteStep],

    props: {},

    data() {
        const date = new Date();
        const year = date.getFullYear();

        return {
            subSteps: ["default"],
            disabledDates: {
                to: new Date(year, date.getMonth(), date.getDate()),
                from: new Date(year + 1, date.getMonth(), date.getDate())
            }
        };
    },

    methods: {
        handleInsuranceStartDate() {
            console.log(this.form[this.stepName].startDate);
            if (this.form[this.stepName].whenStart === this.constants.today) {
                this.form[this.stepName].startDate = moment().toDate();
            } else if (
                this.form[this.stepName].whenStart === this.constants.nextMonth
            ) {
                this.form[this.stepName].startDate = moment()
                    .set("D", 1)
                    .add(1, "M")
                    .toDate();
            }
        }
    },

    watch: {
        "form.HomeQuoteSelectDate.whenStart": {
            deep: true,
            handler() {
                this.handleInsuranceStartDate();
            }
        }
    },

    computed: {
        endDate() {
            if (!this.stepFormFields.startDate) {
                return null;
            }

            return moment(this.stepFormFields.startDate)
                .add({ year: 1 })
                .endOf("month")
                .subtract({ month: 1 })
                .endOf("month")
                .set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
        },
        whenStart() {
            let months = {
                "01": "ינואר",
                "02": "פברואר",
                "03": "מרץ",
                "04": "אפריל",
                "05": "מאי",
                "06": "יוני",
                "07": "יולי",
                "08": "אוגוסט",
                "09": "ספטמבר",
                "10": "אוקטובר",
                "11": "נובמבר",
                "12": "דצמבר"
            };

            return [
                {
                    label: this.trans("from_today"),
                    value: this.constants.today
                },
                {
                    label:
                        "מ-1 ב" +
                        months[
                            moment(new Date())
                                .add({
                                    month: 1
                                })
                                .startOf("month")
                                .format("MM")
                        ],
                    value: this.constants.nextMonth
                },
                {
                    label: this.trans("different_date"),
                    value: this.constants.custom
                }
            ];
        },
        canMoveNext() {
            const currentStep = this.form[this.stepName];

            // Constants for ease of use and readability
            const { structure } = this.constants;

            const {
                whenStart,
                insuranceType
                // earthQuake,
                // pipelineDamage
            } = currentStep;

            // Checking if a value is not null
            const isNotNull = value => value !== null;

            // Basic checks
            // const hasStartDate = !!whenStart;
            //
            // console.log(whenStart);

            // Check for insuranceType being structure and both earthQuake and pipelineDamage being not null
            const hasRequiredFieldsForStructure = insuranceType === structure;
            // isNotNull(earthQuake) &&
            // isNotNull(pipelineDamage);

            // Putting all conditions together
            // If insuranceType is structure, it checks for required fields for structure,
            // otherwise it checks for content amount.
            // return (
            //     // hasStartDate &&
            //     hasRequiredFieldsForStructure
            // );

            return true;
        },
        insuranceType() {
            return [
                {
                    label: this.trans("content_structure"),
                    value: this.constants.content_structure
                },
                {
                    label: this.trans("content"),
                    value: this.constants.content
                },
                {
                    label: this.trans("structure"),
                    value: this.constants.structure
                }
            ];
        },
        insuredConnection() {
            return [
                {
                    label: this.trans("home_owner"),
                    value: this.constants.home_owner
                },
                {
                    label: this.trans("home_renter"),
                    value: this.constants.home_renter
                }
            ];
        },
        earthQuakeItem() {
            return [
                {
                    label: this.trans("not_include"),
                    value: this.constants.not_include
                },
                {
                    label: this.trans("include"),
                    value: this.constants.include
                }
            ];
        },
        pipelineDamageItem() {
            return [
                {
                    label: this.trans("plumber_in_order"),
                    value: this.constants.plumber_in_order
                },
                {
                    label: this.trans("plumber_private"),
                    value: this.constants.plumber_private
                }
            ];
        },
        isContentType() {
            let form = this.form[this.stepName];
            return (
                form.insuranceType === this.constants.content_structure ||
                form.insuranceType === this.constants.content
            );
        },
        jewelryAmount() {
            let jewelryPercent = 0.1;
            let amount = this.form[this.stepName].contentAmount
                ? (
                      this.form[this.stepName].contentAmount * jewelryPercent
                  ).toFixed(1)
                : "";

            // Add the NIS sign (₪) to the end
            return amount ? amount + " ₪" : "";
        }
    }
};
</script>

<style lang="scss" scoped>
.home-quote-step {
    .quote-form {
        max-width: $mobile;
        height: auto;
        margin: 0 auto;
    }

    .notice-message {
        font-size: 25px;
        font-weight: $font-light;
        line-height: 1.32;
        color: $primary-blue;
        margin-top: 30px;
    }

    .quote-form {
        margin-top: 40px;
        display: flex;
        flex-direction: column;
        gap: 60px;
    }

    .quote-form {
        margin-top: 0 !important;
        max-width: $tablet;
        height: auto;
        margin: 0 auto;
    }
}

.start-insurance-date {
    text-align: center;
    width: 100%;
}

.app-date-input {
    width: 100%;
    border-radius: 100px;
    border: 1px solid rgba(33, 67, 146, 0.2);
    background: $lightest-gray;

    input {
        font-size: 24px;
        height: 50px;
        margin: 0;

        @media all and (max-width: $mobile) {
            font-size: 21px;
        }
    }
}
</style>
